import RemoveFromBasketRequestModelBase from '../_generated/modelBases/remove-from-basket-request-model-base';

export default class RemoveFromBasketRequestModel extends RemoveFromBasketRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
